module.exports = __webpack_public_path__ + "static/media/bolle.af21c9d2.png";